export enum STOREFRONT_VALUES_NAMESPACES {
    GROWAVE_CRITICAL = "growave_critical",
    REVIEWS_CRITICAL = "reviews_critical",
    REWARDS_CRITICAL = "rewards_critical",
    WISHLIST_CRITICAL = "wishlist_critical",
    GIFT_REGISTRY_CRITICAL = "gift_registry_critical",
}

export enum STOREFRONT_VALUES_KEYS {
    WATERMARK = "watermark",
    CHECKOUT_UI = "checkout_UI",
    ACCOUNT_UI = "account_UI",
    REWARDS_PROGRAMS_STATUS = "rewards_programs_status",
    REWARDS_SETTINGS = "rewards_settings",
    REWARDS_CUSTOMERS_ELIGIBILITY = "rewards_customers_eligibility",
    REWARDS_BRANDING = "rewards_branding",
    REWARDS_POS_SETTINGS = "rewards_pos_settings",
    REVIEWS_SETTINGS = "reviews_settings",
    REVIEWS_BRANDING = "reviews_branding",
    QUESTIONS_SETTINGS = "questions_settings",
    WISHLIST_SETTINGS = "wishlist_settings",
    WISHLIST_BRANDING = "wishlist_branding",
    GIFT_REGISTRY_SETTINGS = "gift_registry_settings",
}
